import { IFloatingButtonConfig } from '@/domain/interfaces/IFloatingButtonConfig';

/**
 * Enumeración para los tipos de botones flotantes disponibles
 */
export enum FloatingButtonTypes {
  SCROLL_TOP = 'scroll-top',
  CONTACT = 'contact',
}

/**
 * Configuración predeterminada para cada tipo de botón flotante
 */
export const FLOATING_BUTTON_CONFIGS: Record<FloatingButtonTypes, IFloatingButtonConfig> = {
  [FloatingButtonTypes.SCROLL_TOP]: {
    defaultIcon: 'ico-up-arrow',
    defaultAction: () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    styleClass: 'floating-button-scroll-top',
  },
  [FloatingButtonTypes.CONTACT]: {
    defaultIcon: 'ico-contact-button',
    defaultAction: () => {},
    styleClass: 'floating-button-contact',
  },
};
